export interface ButtonContainerProps {
  spacing: {
    paddingRight: number;
    paddingLeft: number;
  };
}

export const QuestionCardStyles = () => `
  margin-top: 24px;
`;

export const QuestionTitleStyles = () => `
  font-style: normal;
  font-size: 15px;
  line-height: 24px;
`;

export const QuestionAnswerStyles = () => `
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 18px;
`;

export const QuestionNoAnswerStyles = () => `
  font-style: italic;
  font-weight: 300;
  font-size: 14px;
  line-height: 20px;
`;

export const QuestionAnswerBlueStyles = (props: any) => `
  font-style: italic;
  font-weight: 400;
  font-size: 11px;
  line-height: 20px;
  color: ${props.theme.primary.c500};
  margin-left: 8px;
`;

export const QuestionUnitAnswerStyles = () => `
  display: flex;
  flex-direction: row;
  align-items: baseline;
`;

export const QuestionButtonsContainerStyles = () => `
  margin-top: 16px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;

const paddingProps = (props: any) => {
  if (props.spacing) {
    return `
      padding-right: ${props.spacing.paddingRight ? props.spacing.paddingRight : 0}px;
      padding-left: ${props.spacing.paddingLeft ? props.spacing.paddingLeft : 0}px;
    `;
  }
  return ``;
};

export const QuestionButtonContainerStyles = (props: any) => `
  flex: 1;
  ${paddingProps(props)}
`;

export const QuestionSeparatorStyles = () => `
  width: 16px;
`;

export const QuestionEditContainerStyles = () => `
  position: absolute;
  right: 16px;
  top: 16px;
`;

export const QuestionNoteIconContainerStyles = () => `
  margin-top: 16px;
`;

export const QuestionDateContainerStyles = () => `
  margin-top: 16px;
`;
